<template>
  <div class="flex flex-col justify-between">
    <h1 class="w-full bg-b2c-grey-100 text-black text-center
    font-bold tracking-widest uppercase py-6 text-md mb-2">
      {{question}}
    </h1>
    <div class="flex flex-row justify-between my-2 text-sm w-1/2 mx-auto">
        <button
          @click="$emit('close')"
          class="px-4 py-3 rounded border bg-b2c-red-300 border-b2c-red-300
          hover:bg-white text-white hover:text-b2c-red-300 font-bold cursor-pointer mb-3">
            {{$t('addresses.cancel')}}
        </button>
        <button
          @click="deleteAddress"
          class="px-4 py-3 rounded border  bg-b2c-red-300 border-b2c-red-300
          hover:bg-white text-white hover:text-b2c-red-300 font-bold cursor-pointer mb-3">
            {{ do_it }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import store from '@/store/index';

export default {
  props: ['question', 'do_it', 'addressToDeleteId'],

  methods: {
    deleteAddress() {
      axios.delete(`/api/addresses/${this.addressToDeleteId}`).then(() => {
        store.dispatch('auth/auth');
        this.$emit('close');
      }).catch((error) => {
        this.$emit('close');
        this.checkSessionErrorNotification(error);
      });
    },
  },
};
</script>
